<template>
  <ValidationObserver
    ref="actionObserver" >
    <div
      v-for="(action, index) in actions"
      :key="index"
      class="action-fields" >
      <span class="action-header flex center-all gap-8">and</span>
      <b-form-group :class="{ 'has-subtitle': action.value && action.value.subtitle }">
        <div class="option flex gap-10 relative">
          <div class="flex column gap-8 greedy">
            <ValidationProvider
              v-slot="{ errors }"
              :name="`action-${index}`"
              rules="required">
              <multiselect
                v-model="action.value"
                class="flex-options hide-tags no-selected-background"
                :options="availableOptions[index]"
                label="label"
                track-by="value"
                :multiple="false"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="true"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="false"
                :preselect-first="true"
                :searchable="false" >
                <template
                  slot="selection"
                  slot-scope="{ values }">
                  <span
                    v-if="values.length"
                    class="multiselect__single" >{{ values }}</span>
                </template>
                <template
                  slot="singleLabel"
                  slot-scope="value">
                  <span
                    v-if="true"
                    class="multiselect__single"
                    :class="{ 'image': value.option.image }"
                    :style="{ backgroundImage: `url(${value.option.image})` }" >{{ value.option.label }}</span>
                </template>
                <template
                  slot="option"
                  slot-scope="props">
                  <span
                    class="greedy"
                    :class="{ 'image': props.option.image }"
                    :style="{ backgroundImage: `url(${props.option.image})` }" >{{ props.option.label }}</span>
                  <SBIcon
                    :icon="SBIconList.DONE_CIRCLE"
                    :color="SBColors.bluePrimary"
                    :size="13"/>
                </template>
              </multiselect>
            </ValidationProvider>

            <div
              v-if="action.value && action.value.type && action.value.type === 'email'">
              <ValidationProvider
                v-slot="{ errors: errorsEmail, failedRules }"
                name="Email"
                rules="required|email">
                <b-input
                  v-model="action.context"
                  autocomplete="off"
                  class="mt-2 sb2-bordered sb2-hoverable sb2-focusable"
                  :class="{ empty: !action.context}"
                  placeholder="email@company.com" />
                <div
                  v-if="errorsEmail[0]"
                  class="error flex flex-align-center">
                  <SBIcon
                    class="mr-1"
                    :icon="SBIconList.ERROR"
                    :color="SBColors.redPrimary"
                    :size="12" />
                  <span>{{ errorsEmail[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
          </div>

          <!-- <input
            :id="`buttonInput-${index}`"
            :ref="`buttonInputRef-${index}`"
            v-model="button.value"
            :maxlength="buttonMaxTextLength"
            type="text"
            class="w-100 sb2-active sb2-bordered sb2-hoverable sb2-focusable option-item mb-0"
            placeholder="Enter button text" > -->
            
          <SBIcon
            v-if="showRemoveAction"
            class="delete"
            :class="{ 'outside-right': closeBtnRight }"
            :icon="SBIconList.CLOSE_THIN"
            :size="10"
            :color="SBColors.greyPrimary"
            :hover-icon-color="SBColors.blackPrimary"
            @click="removeOption(index)" />
        </div>
          
        <!-- <div
          v-if="errors[0]"
          class="error flex flex-align-center">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.ERROR"
            :color="SBColors.redPrimary"
            :size="12" />
          <span>Button text is required.</span>
        </div> -->
      </b-form-group>

      <div
        v-if="action.value && action.value.subtitle"
        class="subtitle flex flex-align-center">
        <svg
          v-if="action.value.subtitlePrefixIcon && typeof action.value.subtitlePrefixIcon === 'string' && action.value.subtitlePrefixIcon.endsWith('.svg')"
          class="mr-1 flex-start-image"
          :data-src="action.value.subtitlePrefixIcon"
          fill="currentColor"
          width="10"
          height="10" />
        <img
          v-else-if="action.value.subtitlePrefixIcon && typeof action.value.subtitlePrefixIcon === 'string'"
          :src="action.value.subtitlePrefixIcon"
          style="width: 10px; height: 10px;"
          class="mr-1"
        >
        <SBIcon
          v-else-if="!schema.noSubtitlePrefixIcon"
          class="mr-1"
          :icon="SBIconList.INFO"
          :color="SBColors.greyLight"
          :size="10" />
        <span>{{ action.value.subtitle }}</span>
      </div>
    </div>
    <!-- <pre class="debug">{{ actions.length }} {{ schema.options.length }}</pre> -->
    <div
      v-if="actions.length < schema.options.length"
      class="add-more-action"
      @click="addNewAction">
      <span class="flex flex-align-center">
        <svg
          v-if="schema.addActionIcon && typeof schema.addActionIcon === 'string' && schema.addActionIcon.endsWith('.svg')"
          class="mr-1 flex-start-image"
          :data-src="schema.addActionIcon"
          fill="currentColor"
          width="10"
          height="10" />
        <img
          v-else-if="schema.addActionIcon && typeof schema.addActionIcon === 'string'"
          :src="schema.addActionIcon"
          style="width: 10px; height: 10px;"
          class="mr-1"
        >
        <SBIcon
          v-else-if="!schema.noAddActionIcon"
          class="mr-2"
          :icon="SBIconList.PLUS"
          :color="schema.blackButtons ? SBColors.blackPrimary : SBColors.bluePrimary"
          :size="10" />
        <span>{{ schema.addActionText }}</span>
      </span>
    </div>
  </ValidationObserver>
</template>

<script>
import Multiselect from 'vue-multiselect';

import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'NMBRActionsWrapper',
  components: {
    Multiselect,
    SBIcon,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    // validators: {
    //   type: String,
    //   default: '',
    // },
    schema: {
      type: Object,
      default: () => ({}),
    },
    closeBtnRight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      actions: [],
      returnData: [],
      SBColors,
      SBIconList,
    };
  },
  computed: {
    /** List of values that are selected in the action buttons. */
    selectedValues() {
      return this.actions.map(action => action.value.value);
    },
    /** Sets the options list for each action based on the already selected values. */
    availableOptions() {
      const availableOptions = [];

      this.actions.forEach((action, index) => {
        availableOptions.push(JSON.parse(JSON.stringify(this.schema.options)).map(option => ({
          ...option,
          $isDisabled: option.value !== action.value.value && this.selectedValues.includes(option.value),
        })));
      });
      return availableOptions;
    },
    /** Just a placeholder for now if we decide to implement some logic for action removal. */
    showRemoveAction() {
      return true;
    },
  },
  watch: {
    actions: {
      handler() {
        this.$nextTick(() => {
          this.returnData = this.actions.map(action => ({
            value: action.value.value || action.value,
            ...(action.context && { context: action.context }),
          }));
          this.emitData();
        });
      },
      deep: true,
    },
  },
  mounted() {
    if (this.schema.value) {
      // this.actions = this.schema.value.map(action => ({ value: this. }));
      const options = JSON.parse(JSON.stringify(this.schema.options));
      this.schema.value.forEach((action) => {
        const targetOption = options.find(option => option.value === action.value);
        this.actions.push({ value: targetOption || '', ...(action.context && { context: action.context }) });
      });
    }
    if (this.schema.stepID) {
      this.$eventBus.$on(`validate-${this.schema.stepID}`, () => {
        if (!this.$refs.actionObserver) return;
        this.$refs.actionObserver.validate();
        this.emitData();
      });
    }
    setTimeout(() => {
      this.emitData(true);
      // if (this.schema.value) {
      //   this.$refs.buttonsObserver.validate();
      // }
    }, 0);
  },
  methods: {
    addNewAction() {
      this.actions.push({ value: '' });
      setTimeout(() => {
        if (this.actions[this.actions.length - 1].value === '') {
          // console.log('----', this.availableOptions[this.availableOptions.length - 1]);
          // console.log(this.availableOptions[this.availableOptions.length - 1].find(option => !option.$isDisabled));
          this.actions[this.actions.length - 1].value = this.availableOptions[this.availableOptions.length - 1].find(option => !option.$isDisabled);
        }
        this.emitData();
      }, 0);
    },
    removeOption(index) {
      this.actions.splice(index, 1);
      setTimeout(() => {
        this.emitData();
      }, 0);
    },
    /**
     * Sets the data for the actions from the outside component mostly for edit purposes
     * @param {Array} actionList List of buttons to set. Each button should be a string. e.g. ['button1', 'button2', 'button3']
     */
    setData(actionList) {
      this.actions = [];
      const options = JSON.parse(JSON.stringify(this.schema.options));
      actionList.forEach((action) => {
        const targetOption = options.find(option => option.value === action.value);
        this.actions.push({ value: targetOption || '', ...(action.context && { context: action.context }) });
      });
    },
    emitData(reset = false) {
      // console.log(1);
      // console.log('this.$refs.buttonsObserver', this.$refs.buttonsObserver); return;
      if (!this.$refs.actionObserver) return;
      // console.log(2);
      this.$refs.actionObserver.validate({ silent: true })
        .then((valid) => {
          // console.log(3, valid);
          this.$emit('input', {
            valid,
            name: this.schema.returnKey || '',
            data: {
              value: this.returnData,
            },
          });
        })
        .finally(() => {
        //   if (reset) this.$refs.buttonsObserver.reset();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.action-header {
  text-transform: uppercase;
  margin: 8px 0;
  font-size: 11px;
  font-weight: 500;
  color: $blackUltralight;

  &:after {
    content: '';
    height: 1px;
    border-bottom: 1px dashed $greyBorder;
    flex-grow: 2;
  }
}

.action-fields {
  .form-group {
    &.has-subtitle {
      margin-bottom: 0 !important;
    }
  }
}

.add-more-action {
  // display: inline-block;
  color: $bluePrimary;
  padding: 0 0 0 0;
  margin-top: 8px;

  span {
    font-weight: 500;
    font-size: 14px;
  }

  &:hover {
    cursor: pointer;
    color: $blackPrimary;
    ::v-deep .sb-icon .mask {
      background-color: $blackPrimary !important;
    }
  }
}

.option {
  .option-item {
    margin-bottom: 10px;
  }

  .delete {
    // margin-right: 0 !important;
    margin-top: 12px;
    cursor: pointer;

    &.outside-right {
      position: absolute;
      right: -23px;
    }
  }

  &:hover {
    .delete {
      display: flex;
    }
  }
}

.error * {
  font-size: 12px !important;
  line-height: 1 !important;
}

::v-deep .flex-options {
  .multiselect__select, .multiselect__tags {
    height: 34px !important;
  }
}

input.form-control {
  height: 34px;
}
</style>
